var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logout_00000062163532901910616030000008769805512882552734_",
    gradientUnits: "userSpaceOnUse",
    x1: -505.5255,
    y1: 548.0256,
    x2: -505.5255,
    y2: 547.0256,
    gradientTransform: "matrix(40.0017 0 0 -40.0017 20241.8926 21921.9648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0071BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A043C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "logout",
    style: {
      fill: "url(#logout_00000062163532901910616030000008769805512882552734_)"
    },
    d: "M11.4,28.5 c0.6,0.6,1.5,0.6,2.1,0c0,0,0,0,0,0l6.5-6.4l6.5,6.5c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.8-0.2,1-0.4c0.6-0.6,0.6-1.5,0-2c0,0,0,0,0-0.1 L22.1,20l6.5-6.5c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.2-0.8-0.4-1c-0.6-0.6-1.5-0.6-2-0.1c0,0,0,0-0.1,0.1L20,17.9l-6.5-6.5 c-0.3-0.3-0.6-0.4-1-0.4c-0.4,0-0.8,0.2-1,0.4c-0.6,0.6-0.6,1.5,0,2.1c0,0,0,0,0,0l6.4,6.5l-6.5,6.5c-0.3,0.3-0.4,0.6-0.4,1 C11,27.9,11.2,28.3,11.4,28.5z M20,40c-2.7,0-5.4-0.5-7.9-1.5c-4.8-2-8.6-5.8-10.6-10.6C0.5,25.4,0,22.7,0,20c0-2.7,0.5-5.4,1.5-7.9 c1-2.4,2.4-4.5,4.2-6.3C9.5,2,14.7-0.1,20,0c11-0.1,19.9,8.7,20,19.7c0,0.1,0,0.2,0,0.3c0.1,5.3-2,10.5-5.8,14.2 c-1.8,1.8-4,3.2-6.4,4.2C25.4,39.5,22.7,40,20,40z M20,37c4.5,0.1,8.9-1.7,12-5c3.3-3.1,5.1-7.5,5-12c0.1-4.5-1.7-8.9-5-12 c-3.1-3.3-7.5-5.1-12-5c-4.5-0.1-8.9,1.7-12,5c-3.3,3.1-5.1,7.5-5,12c-0.1,4.5,1.7,8.9,5,12C11.1,35.3,15.5,37.1,20,37z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutPurple);
export default __webpack_public_path__ + "static/media/logout_purple.e17ae1c61f174db528b80eea26aa63ee.svg";
export { ForwardRef as ReactComponent };